import "./../assets/css/style.css";
import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ImgBanner } from "./banner";
import { BoxInstall, BoxTitle } from "./box";
import { Section } from "./section";
import { Title, TitleDestaque } from "./Text";
import { BoxApp } from "./box";

import ImageCelphone from "../img/2025/app/appBlack.png";
import ImageCelphoneCyber from "../img/2025/app/appBlack.png";
import Imgapp from "../img/app/app-store.png";
import Imggoogle from "../img/app/google-play.png";

function Install() {
  const [dataAtingida, setDataAtingida] = useState(false);
  const dataDeMudanca = new Date("2025-12-01T00:00:00");

  useEffect(() => {
    const verificarData = () => {
      const dataAtual = new Date();

      if (dataAtual >= dataDeMudanca) {
        setDataAtingida(true);
      }
    };

    verificarData();

    const intervalo = setInterval(verificarData, 60000);

    return () => clearInterval(intervalo);
  }, []);

  return (
    <Section className="c-Install">
      <div className="container">
        <div className="row justify-content-center container-app">
          <BoxApp className="col-12 col-md-12">
            <div className="d-flex flex-wrap justify-content-center">
              <div className="position-relative col-md-6">
                <img
                  className="app-install"
                  src={`${
                    dataAtingida
                      ? ImageCelphoneCyber
                      : ImageCelphone
                  }`}
                />
              </div>
              <div className="d-flex flex-column justify-content-center col-md-6">
                <Title className="d-md-block">
                  Os melhores produtos na <span className={`install-texto-destaque ${dataAtingida ? "cyber" : ""}`}>palma da sua mão</span>
                </Title>
                <p>Baixe o APP e garanta condições exclusivas de Cashback.</p>
                <div className="container-install d-flex">
                  <BoxInstall className={` ${dataAtingida ? "cyber" : ""}`}>
                    <a href="https://apps.apple.com/br/app/futfanatics/id1422835821">
                      <img className="image-install" src={Imgapp} />
                    </a>
                  </BoxInstall>
                  <BoxInstall className={` ${dataAtingida ? "cyber" : ""}`}>
                    <a href="https://play.google.com/store/apps/details?id=com.futfanatics">
                      <img className="image-install" src={Imggoogle} />
                    </a>
                  </BoxInstall>
                </div>
              </div>
            </div>
          </BoxApp>
        </div>
      </div>
    </Section>
  );
}

export default Install;
